<div class="pt-1 pb-4" style="padding-left: 35px">
  @if (publikation.textEigentumBisher) {
    <span>
      <div>
        <strong>{{ "EigentümerBisher" | translate }}</strong>
      </div>
      <div>{{ publikation.textEigentumBisher }}</div>
    </span>
  }

  @if (publikation.textEigentumNeu) {
    <span>
      <div>
        <strong>{{ "EigentümerNeu" | translate }}</strong>
      </div>
      <div>{{ publikation.textEigentumNeu }}</div>
    </span>
  }

  @if (publikation.textSonderrecht) {
    <span>
      <div>
        <strong>{{ "MitSonderrechten" | translate }}</strong>
      </div>
      <div>{{ publikation.textSonderrecht }}</div>
    </span>
  }

  @if (publikation.textGebaeude) {
    <span>
      <div>
        <strong>{{ "MitGebäuden" | translate }}</strong>
      </div>
      <div>{{ publikation.textGebaeude }}</div>
    </span>
  }
  @if (publikation.bemerkung) {
    <span>
      <div>
        <strong>{{ "Bemerkung" | translate }}</strong>
      </div>
      <div>{{ publikation.bemerkung }}</div>
    </span>
  }
</div>
